import { View } from "@react-pdf/renderer";

const PdfBox = ({ children, style }) => {
  return <View style={style}>{children}</View>;
};

export default PdfBox;
